import { render, staticRenderFns } from "./WeeklyEDIPage.vue?vue&type=template&id=4c2e0190&scoped=true"
import script from "./WeeklyEDIPage.vue?vue&type=script&lang=js"
export * from "./WeeklyEDIPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2e0190",
  null
  
)

export default component.exports